/** Attach a freshly posted reply to thread context before /context refresh returns. */
export const STATUS_POSTED_AS_REPLY = 'STATUS_POSTED_AS_REPLY';

export function statusPostedAsReply(status) {
  return {
    type: STATUS_POSTED_AS_REPLY,
    status,
  };
}
